import { Line } from "@react-three/drei";
import { useMemo } from "react";
import { type Path, Vector3 } from "three";
import { RENDER_QUALITY } from "./Shape";

interface OutlineProps {
	path: Path;
	thickness: number;
	active?: boolean;
}

export function Outline({ path, thickness, active }: OutlineProps) {
	const lineWidth = 1.5;
	const lineColor = active ? "#BF920D" : "#285D6D";

	const baseLine = useMemo(() => path.getPoints(RENDER_QUALITY), [path]);

	const firstPoint = baseLine[0];
	const lastPoint = baseLine[baseLine.length - 1];

	const leftLine = useMemo(() => {
		if (!(firstPoint && lastPoint)) return null;

		return [
			new Vector3(firstPoint.x, firstPoint.y, 0),
			new Vector3(firstPoint.x, firstPoint.y, thickness),
		];
	}, [firstPoint, lastPoint, thickness]);

	const rightLine = useMemo(() => {
		if (!(firstPoint && lastPoint)) return null;

		return [
			new Vector3(lastPoint.x, lastPoint.y, 0),
			new Vector3(lastPoint.x, lastPoint.y, thickness),
		];
	}, [firstPoint, lastPoint, thickness]);

	if (!(leftLine && rightLine)) return null;

	return (
		<>
			<Line points={leftLine} color={lineColor} lineWidth={lineWidth} />
			<Line points={rightLine} color={lineColor} lineWidth={lineWidth} />
			<Line points={baseLine} color={lineColor} lineWidth={lineWidth} />
			<Line
				points={baseLine}
				color={lineColor}
				lineWidth={lineWidth}
				position={[0, 0, thickness]}
			/>
		</>
	);
}
